export default {
    askEve: "Ask Eve",
    controlHub: "Control Hub",
    dashboard: "Dashboard",
    calendar: "Calendar",
    containers: "Container",
    activity: "Activity",
    quotes: "Quotes",
    orders: "Orders",
    receivers: "Business Partners",
    businessPartners: "Business Partners",
    shippers: "Shippers",
    team: "Team",
    addressBook: "Address Book",
    settings: "Settings",
    companies: "Companies",
    support: "Support",
    logout: "Logout",
    documents: "Documents",
    eveDrive: "Eve Drive",
    liveTracking: "Live Tracking",
    workflows: "Workflows",
    knowledgeBase: "Knowledge Base",
    analytics: "Analytics",
    unreadNotifications: "{{count}} unread notifications",
};
